#version 300 es
precision mediump float;
in vec2 vUV;
out vec4 fragColor;
void main() {
  float y = vUV.y;

  vec3 zenith = vec3(0.22, 0.40, 0.82);
  vec3 horizon = vec3(0.68, 0.78, 0.90);
  vec3 ground = vec3(0.32, 0.48, 0.22);

  // Sun glow near horizon (right side, matching directional light)
  float sunX = 0.65;
  float sunDist = length(vec2(vUV.x - sunX, (y - 0.35) * 2.0));
  float sunGlow = exp(-sunDist * sunDist * 8.0) * 0.35;
  vec3 sunColor = vec3(1.0, 0.9, 0.7);

  vec3 sky;
  if (y > 0.35) {
    float t = (y - 0.35) / 0.65;
    t = t * t;
    sky = mix(horizon, zenith, t);
  } else {
    float t = y / 0.35;
    sky = mix(ground, horizon, t);
  }

  sky += sunColor * sunGlow;
  fragColor = vec4(sky, 1.0);
}
